import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[10000] bg-zinc-900 text-white text-sm py-2 px-4 flex items-center justify-center gap-2"
      style={{ paddingTop: 'calc(0.5rem + env(safe-area-inset-top))' }} role="status" data-testid="offline-banner">
      <WifiOff className="w-4 h-4" />
      Sem ligação — algumas funções podem não estar disponíveis
    </div>
  );
};

export default OfflineBanner;
